/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/file_pdf_medium'
export default icon
